export const utmEnumsDetailsInput: { [key: string]: string } = Object.freeze({
  ['source']: 'utm_source',
  ['medium']: 'utm_medium',
  ['campaign']: 'utm_campaign',
  ['term']: 'utm_term',
  ['content']: 'utm_content',
});
